export default {
	InvitationCode: "Einladungscode",
	CreditScore: "Kreditwürdigkeit",
	MyFinancial: {
		title: "Mein Finanzen",
		menu: ["Einzahlung", "Abheben", "Transaktion"]
	},
	MyDetail: {
		title: "Mein Detail",
		menu: ["Persönliche Informationen", "Zahlungsmethoden"]
	},
	Other: {
		title: "Andere",
		menu: ["Kontaktieren Sie uns", "Benachrichtigungen", "Sprache ändern"]
	},
	Amount: ["Wallet-Guthaben", "Eingefrorenes Guthaben", "Heutige Einnahmen"],
	Logout: {
		title: "Abmelden",
		content: "Sind Sie sicher, dass Sie sich abmelden möchten?"
	}
};
